import { useState } from "react";

const useModal = () => {
  const [OpenModal, setOpenModal] = useState(false);

  function toggle(status) {
    setOpenModal(!OpenModal);
  }

  function close() {
    setOpenModal(false);
  }

  return {
    OpenModal,
    toggle,
    close
  };
};

export default useModal;
